import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../../styles/MyStyles";
import {GetLookupMenuItems} from "../../../logic/LookupHelper";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetBrokerageAgreementTitle, GetOrderTitle} from "../../../logic/EntityTitleHelper";

const LimitEditPage = () => {
    const { clientId, limitId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [limit, setLimit] = useState({
        contactId: clientId,
        assetId: '',
        brokerageAgreementId: '',
        createdDate: '',
        extensionDate: '',
        extensionVolume: '',
        totalVolume: '',
        reminderVolume: '',
        extensionNumber: '',
        source: ''
    });
    const [agreements, setAgreements] = useState([]);

    useEffect(() => {
        const fetchLimit = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (limitId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_LIMITS_URL}/single/${limitId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setLimit(data.data);
                    } else {
                        console.log('Fetch limit failed.');
                    }
                } else {
                    setLimit({
                        contactId: clientId,
                        assetId: '',
                        brokerageAgreementId: '',
                        createdDate: '',
                        extensionDate: '',
                        extensionVolume: '',
                        totalVolume: '',
                        reminderVolume: '',
                        extensionNumber: '',
                        source: ''
                    });
                    console.log(limit);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        const fetchAgreements = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_AGREEMENTS_URL}/${clientId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + tokenCookie.value,
                        },
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    console.log(data.data);
                    setAgreements(data.data);
                } else {
                    console.log('Fetch agreements failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchAgreements();
        fetchLimit();
    }, [limitId]);

    const validateForm = () => {
        let newErrors = {};

        if (limit.brokerageAgreementId === '') {
            newErrors.brokerageAgreementId = 'Brokerage Agreement is required.';
        }

        if (limit.createdDate === '') {
            newErrors.createdDate = 'Created Date is required.';
        }

        if (limit.extensionDate === '') {
            newErrors.extensionDate = 'Extension Date is required.';
        }

        if (!limit.source.trim()) {
            newErrors.source = 'Source is required.';
        }

        if (limit.assetId === '') {
            newErrors.assetId = 'Asset is required.';
        }

        if (!limit.extensionNumber.trim()) {
            newErrors.extensionNumber = 'Extension Number is required.';
        }

        if (limit.extensionVolume === '' || limit.extensionVolume === 0) {
            newErrors.extensionVolume = 'Extension Volume is required.';
        } else if (isNaN(limit.extensionVolume)) {
            newErrors.extensionVolume = 'Extension Volume must be number.';
        }

        if (limit.totalVolume === '' || limit.totalVolume === 0) {
            newErrors.totalVolume = 'Total Volume is required.';
        } else if (isNaN(limit.totalVolume)) {
            newErrors.totalVolume = 'Total Volume must be number.';
        }

        if (limit.reminderVolume === '') {
            newErrors.reminderVolume = 'Reminder Volume is required.';
        } else if (isNaN(limit.reminderVolume)) {
            newErrors.reminderVolume = 'Reminder Volume must be number.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setLimit({
            ...limit,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_LIMITS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(limit),
                }
            );
            if (response.ok) {
                console.log('Limit updated successfully.');
                handleGoBack();
            } else {
                console.log('Update limit failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const GetAgreementsMenuItems = () => {
        let items = [];
        if (agreements) {
            agreements.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetBrokerageAgreementTitle(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    }

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {limitId ? 'Edit Operation Limit' : 'Create Operation Limit'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Brokerage Agreement</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="brokerageAgreementId"
                                label="Brokerage Agreement"
                                select
                                value={limit.brokerageAgreementId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.brokerageAgreementId}
                                helperText={errors.brokerageAgreementId}
                            >
                                {GetAgreementsMenuItems()}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="assetId"
                                label="Asset"
                                select
                                value={limit.assetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.assetId}
                                helperText={errors.assetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Created Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="createdDate"
                                label="Created Date"
                                value={dayjs(limit.createdDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'createdDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.createdDate}
                                helperText={errors.createdDate}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Extension Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="extensionDate"
                                label="Extension Date"
                                value={dayjs(limit.extensionDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'extensionDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.extensionDate}
                                helperText={errors.extensionDate}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Extension Number</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="extensionNumber"
                                label="Extension Number"
                                value={limit.extensionNumber}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.extensionNumber}
                                helperText={errors.extensionNumber}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Source</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="source"
                                label="Source"
                                value={limit.source}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.source}
                                helperText={errors.source}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Extension Volume</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="extensionVolume"
                                label="Extension Volume"
                                value={limit.extensionVolume}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.extensionVolume}
                                helperText={errors.extensionVolume}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Total Volume</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="totalVolume"
                                label="Total Volume"
                                value={limit.totalVolume}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.totalVolume}
                                helperText={errors.totalVolume}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Reminder Volume</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="reminderVolume"
                                label="Reminder Volume"
                                value={limit.reminderVolume}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.reminderVolume}
                                helperText={errors.reminderVolume}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default LimitEditPage;
